
export const ACTION_BUTTON_COLOR = "#8f8f8f";
export const WARNING_COLOR = '#E85757';
